import { type ComponentPropsWithoutRef, forwardRef } from "react";

export const Input = forwardRef<
  HTMLInputElement,
  ComponentPropsWithoutRef<"input"> & { label?: string }
>(function Input({ className, label, ...props }, ref) {
  return (
    <div className="flex flex-col gap-2">
      {label && <label className="text-sm font-medium">{label}</label>}
      <input
        ref={ref}
        className={`rounded-lg bg-white border border-gray-300 px-3 py-2 text-black disabled:opacity-50 disabled:cursor-not-allowed ${className ?? ""}`.trim()}
        {...props}
      />
    </div>
  );
});
